import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntranceService {
  private amountOfLoadedIcons = 0;
  private showIcons$ = new BehaviorSubject<boolean>(false);
  showIcons = this.showIcons$.asObservable();

  resetIconsAmount(): void {
    this.amountOfLoadedIcons = 0;
  }

  incrementIconsAmount(): void {
    this.amountOfLoadedIcons++;
    if (this.amountOfLoadedIcons === 6) {
      this.showIcons$.next(true);
    }
  };
}

export const EntranceUrl = 'entrance';
